import {observer} from 'mobx-react';
import ActionLink from 'shared/components/links/ActionLink';
import {FormattedMessage} from 'react-intl';

const CustomTableActionLinks = observer(({customTableActionLinks}) => {
  if (!customTableActionLinks) return null;

  return (
    customTableActionLinks.map(action => <ActionLink key={action.label} className='TextLink dodger pl2 py1 inline-block' onClick={() => action.onClick()}>
      <FormattedMessage id={action.label}/>
    </ActionLink>)
  );
});

export default CustomTableActionLinks;
